import { render } from "./OrdenCompra.vue?vue&type=template&id=2efce933&scoped=true"
import script from "./OrdenCompra.vue?vue&type=script&lang=js"
export * from "./OrdenCompra.vue?vue&type=script&lang=js"

import "./OrdenCompra.vue?vue&type=style&index=0&id=2efce933&scoped=true&lang=scss"

import exportComponent from "E:\\laragon\\www\\proyectos\\laravel\\sandy_laravel_vue\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2efce933"]])

export default __exports__